import { z } from "zod";
import { nullishToOptional } from "../../../helpers";
import { DocumentationItemConfigurationV1 } from "./documentation-v1";
import { DocumentationItemConfigurationV2 } from "./documentation-v2";

export const DocumentationGroupBehavior = z.enum(["Group", "Tabs"]);

export const ElementGroupDataV1 = z.object({
  behavior: nullishToOptional(DocumentationGroupBehavior.optional()),
  configuration: nullishToOptional(DocumentationItemConfigurationV1),
});

export const ElementGroupDataV2 = z.object({
  behavior: nullishToOptional(DocumentationGroupBehavior.optional()),
  configuration: nullishToOptional(DocumentationItemConfigurationV2),
});

export type DocumentationGroupBehavior = z.infer<typeof DocumentationGroupBehavior>;
export type ElementGroupDataV1 = z.infer<typeof ElementGroupDataV1>;
export type ElementGroupDataV2 = z.infer<typeof ElementGroupDataV2>;
